module.exports = __webpack_public_path__ + "img/header.aa51db02.png";